"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackNextHelpSlideShow = exports.trackHelpModalShow = void 0;
var _analytics = require("@cian/analytics");
const trackHelpModalShow = offerId => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'distribution_content_modal_open',
    products: [{
      id: offerId
    }],
    page: {
      extra: {
        modal_type: 'purchase_type'
      }
    }
  });
};
exports.trackHelpModalShow = trackHelpModalShow;
const trackNextHelpSlideShow = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Scroll',
    label: 'distribution_content_modal',
    page: {
      extra: {
        modal_type: 'purchase_type'
      }
    }
  });
};
exports.trackNextHelpSlideShow = trackNextHelpSlideShow;